import { dataLocationPin } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLocationPin = /*#__PURE__*/createIcon(dataLocationPin)
export default IconLocationPin
